import Type2 from "./option";

export default Type2;
